export default __webpack_public_path__ + "static/media/suggestion.784bc477.webp";